import { Checkbox, Grid, Group, Text } from '@mantine/core';
import FormHeading from 'apps/Projects/SamplePlans/FormInputs/FormHeading';

import InputAndLabelGridRow from 'common/Components/InputAndLabelGridRow';

import { useProjectsTranslations } from '../hooks';

import { useCarbonPlanConfigQuery } from './queries';

const PhotoDetails = () => {
  const translations = useProjectsTranslations();
  const { samplePlanConfig } = useCarbonPlanConfigQuery();

  return (
    <>
      <FormHeading text={translations.photos} mb="xs" />
      <Grid>
        <InputAndLabelGridRow
          elemId="photos-sample-location"
          label={translations.sampleLocation}
          span={5}
          input={
            <Group gap="xs">
              <Checkbox
                id="photos-sample-location"
                aria-label={translations.sampleLocation}
                disabled={samplePlanConfig?.photos.sample_location.required}
              />
              <Text size="xs">{translations.photosRequiredSampleLocation}</Text>
            </Group>
          }
        />
        <InputAndLabelGridRow
          elemId="photos-field-level"
          label={translations.fieldLevelPhotos}
          span={5}
          input={
            <Group gap="xs">
              <Checkbox
                id="photos-field-level"
                aria-label={translations.fieldLevelPhotos}
                disabled={samplePlanConfig?.photos.field_level_photos.required}
              />
              <Text size="xs">{translations.photosRequiredFieldLevel}</Text>
            </Group>
          }
        />
      </Grid>
    </>
  );
};

export default PhotoDetails;
